/** @jsx isolateComponent */
import { isolateComponent } from '@zapier/style-encapsulation';
import { BaseButton, Props as BaseButtonProps } from '../Button/BaseButton';

export const ButtonNavButton = (props: BaseButtonProps) => {
  return <BaseButton {...props} size="small" />;
};
